import img1 from '../../../assets/images/icon/sketch.svg'
import img2 from '../../../assets/images/icon/bulb.svg'
import img3 from '../../../assets/images/icon/lnterselect.svg'


const feature = [
    {
        id: 1,
        image: img1,
        description:"Quality Customer Service",
    },
    {
        id: 2,
        image: img2,
        description:"Dedicated Support",
    },
    {
        id: 3,
        image: img3,
        description:"We're a True Partner",
    },
]


export default feature